import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { FileSignature } from "lucide-react";

// Pick the MSA and SOW from the Templates Library (Agreements category listed first).
export function AgreementPicker({ msaId, sowId, onChange }) {
  const [templates, setTemplates] = useState([]);
  useEffect(() => { api.get("/templates").then((r) => setTemplates(r.data || [])).catch(() => {}); }, []);

  const groups = templates.reduce((acc, t) => { (acc[t.category] = acc[t.category] || []).push(t); return acc; }, {});
  const cats = Object.keys(groups).sort((a, b) => (a === "Agreements" ? -1 : b === "Agreements" ? 1 : a.localeCompare(b)));

  const select = (testid, value, key, emptyLabel) => (
    <select data-testid={testid} value={value || ""} onChange={(e) => onChange({ [key]: e.target.value })} className="input text-sm w-full">
      <option value="">{emptyLabel}</option>
      {cats.map((c) => (
        <optgroup key={c} label={c}>
          {groups[c].map((t) => <option key={t.id} value={t.id}>{t.name}</option>)}
        </optgroup>
      ))}
    </select>
  );

  return (
    <div className="mt-3 pt-3 border-t border-[var(--line)]" data-testid="agreement-picker">
      <div className="flex items-center gap-1.5 text-xs font-medium mb-2"><FileSignature size={13} /> Agreement documents (signed separately from the LoE)</div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        <div>
          <label className="text-[10px] uppercase tracking-wider text-[var(--ink-2)] block mb-0.5">Master Services Agreement *</label>
          {select("msa-template-select", msaId, "msa_template_id", "— Pick MSA template —")}
        </div>
        <div>
          <label className="text-[10px] uppercase tracking-wider text-[var(--ink-2)] block mb-0.5">Statement of Work</label>
          {select("sow-template-select", sowId, "sow_template_id", "Auto-generate from services")}
        </div>
      </div>
      {!msaId && <div className="text-[11px] text-[var(--warn)] mt-1.5" data-testid="msa-required-note">Pick an MSA before sending. Save your own in Templates → Agreements.</div>}
    </div>
  );
}

export function DocTabs({ letterHtml, msaHtml }) {
  const tabs = [letterHtml && ["loe", "Letter of Engagement", letterHtml], msaHtml && ["msa", "MSA & Statement of Work", msaHtml]].filter(Boolean);
  const [active, setActive] = useState(null);
  const cur = tabs.find((t) => t[0] === active) || tabs[0];
  if (!cur) return <div className="text-xs text-[var(--ink-2)]">Loading preview…</div>;
  return (
    <div>
      <div className="flex gap-1 border-b border-[var(--line)] mb-3">
        {tabs.map(([k, label]) => (
          <button key={k} data-testid={`doc-tab-${k}`} onClick={() => setActive(k)}
            className={`px-3 py-1.5 text-sm border-b-2 -mb-px transition-colors ${cur[0] === k ? "border-[var(--navy)] text-[var(--navy)] font-medium" : "border-transparent text-[var(--ink-2)]"}`}
          >{label}</button>
        ))}
      </div>
      <div data-testid={`${cur[0]}-preview`} className="prose max-w-none text-sm max-h-[600px] overflow-y-auto border border-[var(--line)] rounded p-4 bg-white" dangerouslySetInnerHTML={{ __html: cur[2] }} />
    </div>
  );
}
